import { ModalData } from '@modeso/aumico-lib-core-fe';

export interface ConfirmShareModalData extends ModalData {
    emails: string[];
}
